import 'catalog/components/CatalogList/CatalogList.scss';

import { flatten, uniq, find, isEmpty } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import { LoaderAnim } from '@sm360/widget-commons-basic-components';
import ThemedTile from '@sm360/widget-themed-tile';
import { TILE_MODES } from '@sm360/widget-commons-tiles';

import CatalogFilterModel from 'catalog/models/CatalogFilterModel.js';
import ManufacturerModel from 'catalog/models/ManufacturerModel.js';
import CatalogModelSummaryMapper from 'catalog/mappers/catalogModelSummaryMapper.js';

const CatalogList = ({ catalogFilter, manufacturer, buildAndQuoteUrl, isLoading, displayCreditRate }) => {
    if (isLoading) {
        return (
            <div className="catalog-loader">
                <LoaderAnim />
            </div>
        );
    }

    const manufacturerModels = manufacturer.get('models');
    const models = manufacturerModels ? manufacturerModels.filter((model) => model.get('visible')) : [];

    const filterAvailableBodyStyles = () => {
        const bodyStyles = Array.from(catalogFilter.bodyStyles);
        const bodyStylesWithModels = [];
        models.forEach((model) => {
            bodyStylesWithModels.push(model.bodyStyleCode);
        });
        let bodyStylesToRender = [];
        uniq(flatten(bodyStylesWithModels)).forEach((modelsStyle) => {
            const bodyStyle = find(bodyStyles, (bs) => {
                return bs.codes.includes(modelsStyle);
            });
            if (bodyStyle) {
                bodyStylesToRender = [...bodyStylesToRender, bodyStyle];
            } else {
                console.log('missing', modelsStyle);
            }
        });
        return bodyStylesToRender;
    };

    const tiles = !isEmpty(models) && (
        <ThemedTile theme="tile-a">
            {(Tile) =>
                models.map((model) => {
                    const catalogModelSummary = CatalogModelSummaryMapper.mapToCatalogModelSummary(model);
                    const gaTag = TAGS.MOST_POPULAR_VEHICLES(
                        WindowProxy.location().pathname,
                        catalogModelSummary.model.name
                    );
                    return (
                        <Tile
                            mode={TILE_MODES.CATALOG}
                            key={`${model.make}-${model.model}-${model.bodyStyle}`}
                            model={catalogModelSummary}
                            buildAndQuoteUrl={buildAndQuoteUrl}
                            selectedPurchaseMethod={catalogFilter.purchaseMethodOrder}
                            onClick={() => AnalyticsService.gaTrigger(gaTag)}
                            displayCreditRate={displayCreditRate}
                        />
                    );
                })
            }
        </ThemedTile>
    );

    const filteredValues = filterAvailableBodyStyles();
    const blockedValue = filteredValues && uniq(filteredValues).map((bodyStyle) => bodyStyle.label);
    const selectedFilterLabels = blockedValue && <span>{blockedValue.join(', ')}</span>;

    return (
        <section className="section-listing">
            <div className="result">
                {LocaleService.t('catalogList.headerTitle')}
                <span className="highlight">{selectedFilterLabels}</span>
            </div>
            <div className="list-vehicle">{tiles}</div>
        </section>
    );
};

CatalogList.defaultProps = {
    displayCreditRate: false,
};
CatalogList.propTypes = {
    catalogFilter: PropTypes.instanceOf(CatalogFilterModel).isRequired,
    manufacturer: PropTypes.instanceOf(ManufacturerModel).isRequired,
    buildAndQuoteUrl: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    displayCreditRate: PropTypes.bool,
};

CatalogList.displayName = 'CatalogList';

export default CatalogList;
